import * as React from "react";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import { useBreakpoints } from "../../../../../hooks/useBreakpoins";
import { red } from "@mui/material/colors";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../../hooks/context/useAuth";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ChatIcon from "@mui/icons-material/Chat";
import { Box, IconButton } from "@mui/material";
import { CartPopover } from "../../../Molecules";
import { colors } from "../../../../../theme/colors";

export function LoginPopover({ setTab }: { setTab?: VoidFunction }) {
  const { user, token, logout } = useAuth();
  const { isSmalldesktop, isMobile } = useBreakpoints();
  const nav = useNavigate();
  const { pathname } = useLocation();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const isLogged = user && token ? true : false;
  const isAdmin = user?.user?.role === "admin";

  return (
    <div>
      {isLogged ? (
        <>
          <Box
            display={"flex"}
            flexDirection={isSmalldesktop ? "column" : "row"}
            gap={1}
          >
            {isSmalldesktop ? (
              <Box
                display={"flex"}
                sx={{ mt: isMobile ? 2 : isSmalldesktop ? 4 : 0 }}
              >
                <IconButton
                  onClick={handleClick}
                  style={{
                    marginRight: 5,
                    fontSize: 13,
                    width: 31,
                    color: colors.purple[500],
                  }}
                >
                  <AccountCircleIcon sx={{ mr: 1 }} />
                </IconButton>
                <CartPopover />
              </Box>
            ) : (
              <Box sx={{ display: "flex" }}>
                <Button
                  aria-describedby={id}
                  variant="contained"
                  onClick={handleClick}
                  sx={{
                    minWidth: 150,
                    height: 48,
                  }}
                >
                  {isAdmin ? (
                    <AdminPanelSettingsIcon sx={{ mr: 1 }} />
                  ) : (
                    <AccountCircleIcon sx={{ mr: 1 }} />
                  )}
                  {user?.user?.name?.split(" ")[0]}
                </Button>
                <CartPopover />
              </Box>
            )}
          </Box>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: isMobile ? "center" : "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: isMobile ? "right" : "left",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", width: 150 }}>
              {isAdmin ? (
                <>
                  <Button
                    variant="text"
                    onClick={() => nav("/admin/users")}
                    style={{ height: 60 }}
                    fullWidth
                  >
                    <ContactMailIcon sx={{ mr: 2 }} />
                    Informações do site
                  </Button>
                  <Button
                    variant="text"
                    onClick={() => {
                      localStorage.setItem("@treasure_box_admintab", String(4));
                      nav("/admin/messages");
                    }}
                    style={{ height: 60 }}
                    fullWidth
                  >
                    <ChatIcon sx={{ mr: 2 }} />
                    Mensagens
                  </Button>
                  <Button
                    sx={{
                      p: 0,
                      borderRadius: 0,
                      minHeight: 36,
                      background: red[300],
                      "&: hover": { background: red[100] },
                    }}
                    variant="contained"
                    onClick={() => {
                      logout();

                      nav("/home");
                    }}
                  >
                    <PowerSettingsNewIcon sx={{ mr: 1 }} /> Sair
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="text"
                    onClick={() => nav("/user/my-info")}
                    style={{ height: 60 }}
                    fullWidth
                  >
                    <ContactMailIcon sx={{ mr: 2 }} />
                    Meu perfil
                  </Button>
                  <Button
                    variant="text"
                    onClick={() => nav("/user/favorites")}
                    style={{ height: 60 }}
                    fullWidth
                  >
                    <FavoriteIcon sx={{ mr: 2 }} />
                    Favoritos
                  </Button>
                  <Button
                    variant="text"
                    onClick={() => nav("/user/messages")}
                    style={{ height: 60 }}
                    fullWidth
                  >
                    <ChatIcon sx={{ mr: 2 }} />
                    Mensagens
                  </Button>
                  <Button
                    sx={{
                      p: 0,
                      borderRadius: 0,
                      minHeight: 36,
                      background: red[300],
                      "&: hover": { background: red[100] },
                    }}
                    variant="contained"
                    onClick={() => {
                      logout();

                      nav("/home");
                    }}
                  >
                    <PowerSettingsNewIcon sx={{ mr: 1 }} /> Sair
                  </Button>
                </>
              )}
            </Box>
          </Popover>
        </>
      ) : (
        <Button
          variant={"contained"}
          sx={{
            width: isSmalldesktop ? 150 : 200,
            height: 40,
          }}
          onClick={() => {
            if (pathname === "/user/login") {
              nav("/home");
            } else {
              nav("/user/login");
            }
          }}
        >
          {pathname === "/user/login" ? "Voltar" : "Login"}
        </Button>
      )}
    </div>
  );
}
